import React from 'react';
import PropTypes from 'prop-types';
import { formatValue, breakdownItemShape, stationShape } from './outputPerformanceShared';

export function BreakdownList({ title, items }) {
  return (
    <div className="output-breakdown-card">
      <div className="output-breakdown-title">{title}</div>
      {items.length > 0 ? (
        items.map(item => (
          <div className="output-breakdown-row" key={item.name}>
            <div className="output-breakdown-row-header">
              <span>{item.name}</span>
              {item.hasWeldedCillData ? (
                <div className="output-breakdown-dual">
                  <div className="output-breakdown-dual-item">
                    <strong>{formatValue(item.weldedCillBoxesCreated)}</strong>
                    <small>Boxes</small>
                  </div>
                  <div className="output-breakdown-dual-item">
                    <strong>{formatValue(item.weldedCillTotalFacets)}</strong>
                    <small>{item.weldedCillFacetsLabel || 'Facets'}</small>
                  </div>
                </div>
              ) : item.hasBoxData ? (
                <div className="output-breakdown-dual">
                  <div className="output-breakdown-dual-item">
                    <strong>{formatValue(item.itemsCount)}</strong>
                    <small>Items</small>
                  </div>
                  <div className="output-breakdown-dual-item">
                    <strong>{formatValue(item.boxesCount)}</strong>
                    <small>Boxes</small>
                  </div>
                </div>
              ) : (
                <strong>{formatValue(item.value)}</strong>
              )}
            </div>
            {item.itemTypeDetail?.length > 0 && (
              <ul className="output-item-type-list output-item-type-list--breakdown">
                {item.itemTypeDetail.map(detail => (
                  <li key={detail.name} className="output-item-type-row">
                    <span className="output-item-type-name">{detail.name}</span>
                    <strong className="output-item-type-value">{formatValue(detail.value)}</strong>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))
      ) : (
        <div className="output-breakdown-empty">0</div>
      )}
    </div>
  );
}

BreakdownList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(breakdownItemShape).isRequired
};

export function StationEntry({ entry, onClick }) {
  return (
    <button
      type="button"
      className={`output-benchmark-entry output-benchmark-entry-button ${
        entry.isResolved ? '' : 'is-unresolved'
      }`}
      onClick={onClick}
    >
      <div className="output-benchmark-entry-label-row">
        <div className="output-benchmark-entry-label">{entry.label}</div>
        {!entry.isResolved && (
          <span className="output-unresolved-badge">Unmapped</span>
        )}
      </div>
      {entry.hasWeldedCillData ? (
        <div className="output-benchmark-entry-dual">
          <div className="output-benchmark-entry-dual-item">
            <div className="output-benchmark-entry-value">
              {formatValue(entry.weldedCillBoxesCreated)}
            </div>
            <div className="output-benchmark-entry-dual-label">Boxes</div>
          </div>
          <div className="output-benchmark-entry-dual-item">
            <div className="output-benchmark-entry-value">
              {formatValue(entry.weldedCillTotalFacets)}
            </div>
            <div className="output-benchmark-entry-dual-label">
              {entry.weldedCillFacetsLabel || 'Facets'}
            </div>
          </div>
        </div>
      ) : entry.hasBoxData ? (
        <div className="output-benchmark-entry-dual">
          <div className="output-benchmark-entry-dual-item">
            <div className="output-benchmark-entry-value">
              {formatValue(entry.itemsCount)}
            </div>
            <div className="output-benchmark-entry-dual-label">Items</div>
          </div>
          <div className="output-benchmark-entry-dual-item">
            <div className="output-benchmark-entry-value">
              {formatValue(entry.boxesCount)}
            </div>
            <div className="output-benchmark-entry-dual-label">Boxes</div>
          </div>
        </div>
      ) : (
        <div className="output-benchmark-entry-value">
          {formatValue(entry.value)}
        </div>
      )}
      {entry.itemTypeBreakdown?.length > 0 && (
        <ul className="output-item-type-list">
          {entry.itemTypeBreakdown.map(item => (
            <li key={item.name} className="output-item-type-row">
              <span className="output-item-type-name">{item.name}</span>
              <strong className="output-item-type-value">{formatValue(item.value)}</strong>
            </li>
          ))}
        </ul>
      )}
    </button>
  );
}

StationEntry.propTypes = {
  entry: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    hasBoxData: PropTypes.bool,
    itemsCount: PropTypes.number,
    boxesCount: PropTypes.number,
    hasWeldedCillData: PropTypes.bool,
    weldedCillBoxesCreated: PropTypes.number,
    weldedCillTotalFacets: PropTypes.number,
    weldedCillFacetsLabel: PropTypes.string,
    itemTypeBreakdown: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired
      })
    ),
    isResolved: PropTypes.bool,
    station: stationShape
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
